import { is_valid_full_name, is_valid_vat, clean_vat, is_valid_mail } from './validation';

// Checkout summary functionally
$(function() {
	var $summary = $( '.summary-checkout' );

	if( $summary.length == 0 ) {
		return;
	}

	var $win = $(window);
	var offset_top = 174;
	var fixed_class = 'summary-checkout-fixed';


	function fix_summary() {

		if( $win.scrollTop() >= offset_top && !$summary.hasClass( fixed_class ) ) {
			$summary.addClass( fixed_class );
		}

		if( $win.scrollTop() < offset_top && $summary.hasClass( fixed_class ) ) {
			$summary.removeClass( fixed_class );
		}
	}


	// Events
	$win.scroll( fix_summary );
	$win.resize( fix_summary );
	fix_summary();


	var $list_hidden = $( '.list-summary-hidden' );
	var list_old_text = 'Hide';

	$( '.js-toggle-list-summary-hidden' ).click(function(){
		var $link = $(this);

		$list_hidden.toggleClass( 'list-summary-hidden' );

		// switch the text
		var current_text = $link.text();
		$link.text( list_old_text );
		list_old_text = current_text;

		return false;
	});
});



// Checkout Billing Functionallity
$(function(){
	var $checkout = $( '.checkout-billing' );

	if( $checkout.length == 0 ) {
		return;
	}

	// Selectors
	var $input_invoice_type = $( '[name="invoice_type"]' );
	var $input_country = $( '[name="country_id"]' );

	var $input_tax_id = $( '[name="tax_id"]' );
	var $input_tax_id_parent = $input_tax_id.parents( '.form-row' );

	var $input_vat_id = $( '[name="vat_id"]' );
	var $input_vat_id_number = $( '[name="vat_id_number"]' );
	var $input_vat_id_country_code = $( '[name="vat_id_country_code"]' );

	var $input_vat_id_number_parent = $input_vat_id_number.parents( '.form-row' );

	var $tax_alerts = $( '[rel^="tax-alert-"]' );

	var $sub_total = $( '.js-sub-total' );
	var $tax = $( '.js-tax' );
	var $tax_label = $( '.js-tax-label' );
	var $tax_label_eu_individual = $( '.js-tax-eu-individual' );
	var $total = $( '.js-total' );

	var $input_payment_method = $( '[name="payment_method"]' );
	var $payment_gateway_label = $( '.js-gateway-label' );

	var $payment_gateway_link = $( '.js-gateway-link' );

	var $input_billing_profile = $( '[name="billing_profile_token"]' );

	var $input_save_billing_profile = $( '[name="save_billing_profile"]' );
	var $label_save_billing_profile = $( '[for="field-save-billing-profile"] span' );

	var $loader_billing = $( '.loader-outer' );
	var $btn_continue = $( '[name="continue"]' );

	var $link_other_payment_methods = $( '.js-other-payment-methods' );

	var $vat_prefix = $( '.vat-prefix' );


	// Classes
	var form_row_class_hidden 	= 'form-row-hidden';
	var form_group_class_hidden = 'form-group-hidden';
	var form_alert_class_hidden = 'form-alert-hidden';
	var radio_hidden_class 		= 'radio-hidden';



	// Caching
	$.create_cache = function( request_func ) {
		var cache = {};

		return function( url, data, callback ) {
			var key = url + '--' + get_cache_key( data );

			if ( !cache[ key ] ) {
				cache[ key ] = $.Deferred(function( defer ) {
					request_func( defer, url, data );
				}).promise();
			}

			return cache[ key ].done( callback );
		};
	};


	$.ajax_cached_call = $.create_cache(function( defer, post_url, post_data ) {
		$.ajax({
			url: post_url,
			data: post_data,
			dataType: "json",
			type: "POST",
			success: defer.resolve,
			error: defer.reject
		});
	});


	// Generate cache key
	function get_cache_key( data ) {
		var args = [];

		for (var i in data ) {
			args.push( i + '=' + data[ i ] );
		}

		return args.join( '--' );
	}



	// Switch invoice type
	function switch_invoice_type() {
		var val = $input_invoice_type.filter(':checked').val();

		var $form_groups = $( '.form-group-hideable' );
		$form_groups.addClass( 'form-group-hidden' );

		var $current_form_group = $form_groups.filter( '[rel="' + val + '"]' );
		$current_form_group.removeClass( 'form-group-hidden' );
	}

	// Events
	$input_invoice_type.change( switch_invoice_type );
	$input_invoice_type.filter(':checked').change();


	// Switch tax/vat id
	function toggle_tax_vat_field() {
		var country_id = $input_country.val();

		if( is_eu_country( country_id ) ) {
			// show vat
			$input_vat_id_number_parent.removeClass( form_row_class_hidden );

			// hide tax
			$input_tax_id_parent.addClass( form_row_class_hidden );

			return;
		}

		// hide vat
		$input_vat_id_number_parent.addClass( form_row_class_hidden );

		// show tax
		$input_tax_id_parent.removeClass( form_row_class_hidden );
	}

	// Events and first time calls
	toggle_tax_vat_field();
	$input_country.change( toggle_tax_vat_field );


	// Toggle tax alert
	function toggle_tax_alerts() {
		var id_prefix = 'tax-alert';

		var invoice_type = $input_invoice_type.filter(':checked').val();
		var country_id = $input_country.val();
		var continent = is_eu_country( country_id ) ? 'eu' : 'noneu';
		var country_name = get_country_name( country_id );

		var alert_ids = [
			id_prefix + '-' + invoice_type + '-' + continent, // tax-alert-individual/company-eu/noneu;
			id_prefix + '-' + invoice_type + '-' + country_name // tax-alert-individual/company-bulgaria;
		];


		// hide all alerts
		$tax_alerts.addClass( form_alert_class_hidden );

		for( var i in alert_ids ) {
			$tax_alerts
				.filter( '[rel="' + alert_ids[ i ] + '"]' )
				.removeClass( form_alert_class_hidden );
		}
	}

	// Events and first time calls
	toggle_tax_alerts();
	$input_country.change( toggle_tax_alerts );
	$input_invoice_type.change( toggle_tax_alerts );


	// Update Summary total
	function update_summary_totals() {
		var post_data = {
			'sub_total_amount': $sub_total.attr( 'data-amount' ),
			'currency': $sub_total.attr( 'data-currency' ),
			'invoice_type': $input_invoice_type.filter( ':checked' ).val(),
			'country_id': $input_country.val(),
		}

		$.ajax_cached_call( '/get-checkout-tax', post_data, function(response){
			var tax_percentage = response[ 'tax_percentage' ];
			var text_tax_percentate = tax_percentage > 0 ? ' (' + tax_percentage + '%)' : '';

			$tax.text( response[ 'tax_price' ] );
			$tax_label.text( text_tax_percentate );
			$total.text( response[ 'total_price' ] );

			// Update tax percentage in the alert messages
			$tax_label_eu_individual.text( tax_percentage + '%' );
		});
	}


	// Events
	$input_country.change( update_summary_totals );
	$input_invoice_type.change( update_summary_totals );

	function get_payment_method() {
		switch ( $input_payment_method.attr( 'type' ) ) {
			case 'radio':
				return $input_payment_method.filter( ':checked' ).val();
			break;

			case 'hidden':
				return $input_payment_method.val();
			break;
		}

		return false;
	}


	// Update the payment gateway text
	function update_payment_gateway_text() {
		var payment_gateway = get_payment_gateway( get_payment_method() );

		$payment_gateway_label.text( ' via ' + payment_gateway );
	}

	// Events and first time calls
	update_payment_gateway_text();
	$input_payment_method.change( update_payment_gateway_text );


	// Update the payment gateway link
	function update_payment_gateway_link() {
		var location = window.location;
		var payment_gateway = get_payment_gateway( get_payment_method() );
		var gateway_link = location.protocol + '//' + location.host + location.pathname + '?method=' + payment_gateway;

		$payment_gateway_link.val( gateway_link );
	}

	// Events and first time calls
	if ($payment_gateway_link.length) {
		update_payment_gateway_link();

		$input_payment_method.change( update_payment_gateway_link );

		$payment_gateway_link.click(function() {
			$(this).select();
		});
	}


	// Update country code
	function update_vat_id_country_code() {
		var country_id = $input_country.val();
		var country_iso_code = $input_country.find( 'option[value="' + country_id + '"]' ).attr('data-iso-code');

		$input_vat_id_country_code.val( country_iso_code );

		// empty values
		if( country_iso_code == '' ) {
			country_iso_code = '--';
		}

		$vat_prefix.text( country_iso_code );

		// updated vat id when country code is updated
		update_vat_id();
	}

	// Events
	update_vat_id_country_code();
	$input_country.change( update_vat_id_country_code );


	// hidden Vat id
	function update_vat_id() {
		var vat_id = $input_vat_id_country_code.val() + $input_vat_id_number.val();
		$input_vat_id.val( vat_id );
	}
	update_vat_id();
	$input_vat_id_number.keyup( update_vat_id );
	$input_vat_id_number.blur( update_vat_id );


	// Change billing profile
	function change_billing_profile() {
		var profile_token = $input_billing_profile.val();
		var ajax_url = '/get-billing-profile';

		var fields = {
			'full_name': '',
			'phone': '',
			'mail': '',
			'invoice_type': 'company',
			'country_id': '',
			'company': '',
			'tax_id': '',
			'vat_id': '',
			'vat_id_number': '',
			'vat_id_country_code': '',
			'state': '',
			'city': '',
			'zip': '',
			'street_address': '',
			'payment_method': 'visa'
		};


		// New profiles - use the default values
		if( profile_token == '' ) {
			let new_values = fields;
			update_input_values( fields, new_values );

			$label_save_billing_profile.text( 'Save' );

			return;
		}


		$.ajax_cached_call( '/get-billing-profile', { 'token': profile_token }, function(response){
			update_input_values( fields, response );

			$label_save_billing_profile.text( 'Update' );
		} );

		return;
	}

	function update_input_values( fields, values ) {
		for( var field_name in fields ) {
			var $field = $( '[name="' + field_name + '"]' );

			var field_value = values[ field_name ];
			var field_type = $field.prop( 'type' ).toLowerCase();

			if( field_type == 'radio' ) {
				$field
					.filter( '[value="' + field_value + '"]' )
					.attr( 'checked', true )
			} else {
				$field
					.val( field_value )
			}
		}

		// call the events manually
		toggle_tax_vat_field();
		toggle_tax_alerts();
		switch_invoice_type();
		update_summary_totals();
		update_payment_gateway_text();
		update_vat_id_country_code();
		update_vat_id();
	}

	// Events
	$input_billing_profile.change( change_billing_profile );


	// Show other payment methods
	$link_other_payment_methods.click(function(){

		$input_payment_method
			.parents( '.radio' )
			.removeClass( radio_hidden_class )
			.parents( '.form-row' )
			.removeClass( form_row_class_hidden );

		return false;
	});


	// Show the visible payment method
	function show_selected_payment_method() {
		$input_payment_method
			.filter(':checked')
			.parents( '.radio' )
			.removeClass( radio_hidden_class )
			.parents( '.form-row' )
			.removeClass( form_row_class_hidden );
	}
	show_selected_payment_method();


	// Check if a country is part of EU
	function is_eu_country( country_id ) {
		for( var i in EU_COUNTRIES_IDS ) {
			if( country_id == EU_COUNTRIES_IDS[i] ) {
				return true;
			}
		}

		return false;
	}


	// Get the country name
	function get_country_name( country_id ) {
		return $input_country.find( 'option[value="' + country_id + '"]' ).text().toLowerCase();
	}


	// Get payment gatway for a payment method
	function get_payment_gateway( payment_method ) {
		for( var gateway in PAYMENT_METHODS ) {
			if( PAYMENT_METHODS[ gateway ].indexOf(payment_method) != -1 ) {
				return gateway;
			}
		}
	}



	// Validation
	var $form = $( '.form-validate' );
	var $fields = $( '.field.validate' );


	// Validate a field - add error messages
	function validate_field( $field ) {
		var form_row = $field.parents( '.form-row' );
		var form_row_class_error = 'form-row-error';
		var form_row_class_success = 'form-row-success';

		// success
		if( is_valid_field( $field ) ) {
			form_row
				.removeClass( form_row_class_error );

			return true;
		}

		// error
		form_row
			.addClass( form_row_class_error )

		return false;
	}


	// Validate a field - check if its value is valid
	function is_valid_field( $field ) {
		var val = $.trim( $field.val() );

		// validate email
		if( $field.hasClass( 'validate-mail' ) && !is_valid_mail( val ) ) {
			return false;
		}

		// validate vat
		if( $field.hasClass( 'validate-vat' ) ) {
			// clean and update field
			var vat_number = clean_vat( val );
			$field.val( vat_number );

			// add the prefix - BG, etc.
			var vat_id = $input_vat_id_country_code.val() + vat_number;

			return is_valid_vat( vat_id );
		}

		if( $field.hasClass( 'validate-fullname' ) ) {
			if( !is_valid_full_name( val ) ) {
				return false;
			}
		}

		// validate empty fields
		if( val == '' ) {
			return false;
		}

		return true;
	}


	// Events
	var time_interval;
	$fields.keyup(function(){
		var $field = $( this );

		// Vat & Mail validation should have some delay as well, since the user should enter all email address letters
		if( $field.hasClass( 'validate-vat' ) || $field.hasClass( 'validate-mail' ) ) {
			window.clearTimeout( time_interval );

			time_interval = window.setTimeout(function(){
				validate_field( $field );
			}, 400);

			return;
		}

		// Validate without ajax
		validate_field( $field );
	});

	// Blur field
	$fields.blur( function(){ validate_field( $(this) ); } );

	// Form submit
	$form.submit( function(){
		var num_errors = 0;

		$fields
			.filter( ':visible' )
			.each(function(){
				if( !validate_field( $(this) ) ) {
					num_errors++;
				}
			});

		if( num_errors > 0 ) {
			return false;
		}

		// check the gateway
		// we'll add spinners for 2checkout, paypal and braintree
		var payment_gateway = get_payment_gateway( get_payment_method() );

		if( payment_gateway == '2checkout' || payment_gateway == 'paypal' || payment_gateway == 'braintree' ) {
			$loader_billing.show();
			$btn_continue.val('Loading...');
		}

		return true;
	} );

	var $payment_opts = $('.section-checkout-payment input[type=radio]');
	var has_selected_payment_method = $payment_opts.filter(':checked').length === 1;
	if (!has_selected_payment_method) {
		$payment_opts
			.not(':disabled')
			.first()
			.prop('checked', true)
			.trigger('change');

	}
});
